import React, {useEffect, useRef, useState} from 'react';
import {
	containsProfanity,
	getCssSizeValue,
	getFontSize,
	getHtmlFromRedactorField,
	getIdWithoutSpecialSymbols,
	getMapKey, getPaddingsClassFromData, validateEmailInput, validateInput
} from "@/utils/utils";
import styled from "styled-components";
import GridContainer from "@/components/common/GridContainer";
import Image from "@/components/common/Image";
import Button from "@/components/common/Buttons/Button";
import {BREAKPOINTS, colors} from "@/styles/themeSettings";
import Icon from "@/components/common/Icon/Icon";
import {BUTTON_VARIANTS, ICONS, LOCALES, PAGES, validationErrors} from "@/constants";
import {motion} from "framer-motion";
import {gsap, ScrollTrigger, useGSAP} from '@/utils/gsap';
import {useViewportHeight, useViewportWidth} from "@/hooks/useViewport";
import CustomInput from "@/components/common/CustomInput";
import CustomCheckbox from "@/components/common/CustomCheckbox";
import classNames from "classnames";
import CountrySelector from "@/components/payment/CountrySelector";
import {useRouter} from "next/router";
import postalCodes from 'postal-codes-js';
import {useBranch} from "@/hooks/useBranch";
import PhonePrefixSelector from "@/components/payment/PhonePrefixSelector";
import phone from "phone";
import {useIsDesktop, useIsMobile, useIsTablet} from "@/hooks/useDevice";
import CustomProjectsSelector from "@/components/payment/CustomProjectsSelector";
import useIsWWDSingleAction from "@/hooks/useIsWWDSingleAction";
import useScrollContext from "@/hooks/useScrollContext";
import TextModal from "@/components/ModalVariants/TextModal";
import PayUSecureForm from "@/components/payment/PayUSecureForm";
import useGlobals from "@/hooks/useGlobals";
import RightSide from "@/components/payment/RightBlocks/RightSide";
import PaymentImage from "@/components/payment/PaymentImage";
import SimpleIconButton from "@/components/common/SimpleIconButton";
import {browserName, deviceType as deviceTypeName, osName} from 'react-device-detect';

const StyledPaymentContainer = styled.div`
	//z-index: 1; 
	position: relative;
	background-color: ${({theme}) => theme.colors.platinum};
	font-family: ${({theme}) => theme.fontFamily.StrawfordFont};
	padding: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)} 0;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		z-index: 1;
		padding: ${getCssSizeValue(80, BREAKPOINTS.TABLET)} 0;
	}
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		//padding: 0;
		padding: ${getCssSizeValue(64, BREAKPOINTS.DESKTOP)} 0;
    }
	.label-choose {
		padding-left: 16px;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding-left: 0;
		}
	}	
	.add-payment-card {
		padding-left: 16px;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding-left: 0;
		}
	}
	
	&.not-payment-page {
		margin-top: ${getCssSizeValue(48, BREAKPOINTS.DESKTOP)};
        background-color: ${({theme}) => theme.colors.whiteSmoke};
		padding: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)} 0;
		@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
			padding: ${getCssSizeValue(80, BREAKPOINTS.TABLET)} 0;
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding: ${getCssSizeValue(48, BREAKPOINTS.DESKTOP)} 0;
		}
	}
`

const PaymentsFormContainer = styled(GridContainer)`
	//position: fixed;
	width: 100%;
	//padding: 0 ${getCssSizeValue(70, BREAKPOINTS.DESKTOP)};
	left: 0;
	margin: 0;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		//background-color: rgba(10,40,200,0.4);
		position: absolute;
		padding: 0 ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		position: absolute;
		left: 0;
		margin: 0;
		width: 100%;
		padding: 0 ${getCssSizeValue(70, BREAKPOINTS.DESKTOP)};
	}
`

const PaymentWrapper = styled.div`
    position: relative;
    //height: 100vh;
    //min-height: 100vh;
	height: fit-content;
	//margin-bottom: 56px;
    &.mobile-scrollable {
        height: auto;
    }

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        height: unset;
		min-height: unset;
        margin-top: ${getCssSizeValue(150, BREAKPOINTS.TABLET)};
    }
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        margin-top: ${getCssSizeValue(200, BREAKPOINTS.DESKTOP)};
        height: unset;
    }
    @media (min-width: 1536px) {
        margin-top: ${getCssSizeValue(150, BREAKPOINTS.DESKTOP)};
    }

    &.not-payment-page {
        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            height: unset;
            margin-top: ${getCssSizeValue(150, BREAKPOINTS.TABLET)};
        }
        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            margin-top: ${getCssSizeValue(56, BREAKPOINTS.DESKTOP)};
            height: unset; 
        }
    }
`

const PaymentsTitleWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-end;
	background-color: ${({theme}) => theme.colors.platinum};
	position: relative;
	z-index: 100001;
	padding: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	text-align: left;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		background-color: transparent;
		position: absolute;
		height: ${getCssSizeValue(100, BREAKPOINTS.DESKTOP)};
		top: ${getCssSizeValue(-48, BREAKPOINTS.DESKTOP)};
		left: 0;
		margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
		padding-right: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		padding-left:0;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		text-align: right;
		display: flex;
		align-items: flex-end;
		justify-content: flex-start;
		flex-direction: row;
		position: absolute;
		height: ${getCssSizeValue(100, BREAKPOINTS.DESKTOP)};
		top: ${getCssSizeValue(-78, BREAKPOINTS.DESKTOP)};
		right: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
		margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
		padding-right: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		padding-left: ${getCssSizeValue(52, BREAKPOINTS.DESKTOP)};
		
		&.payment-page {
			padding-left: unset;
            justify-content: flex-end;
            flex-direction: column;
		}
	}
	@media(min-width: 1280px) {
		padding-bottom: 16px;
		margin-bottom: 0;
		height: 70px;
		top: -70px;
		&.payment-page {
			top: ${getCssSizeValue(-78, BREAKPOINTS.DESKTOP)};
			height:${getCssSizeValue(100, BREAKPOINTS.DESKTOP)};
			padding-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
			margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
		}
	}
	@media(min-width: 1536px) {
		//top: ${getCssSizeValue(-100, BREAKPOINTS.DESKTOP)};
		top: -100px;
		height: 100px;
		padding-bottom: 16px;
		margin-bottom: 0;
        &.payment-page {
			top: ${getCssSizeValue(-108, BREAKPOINTS.DESKTOP)};
			padding-bottom: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
        }
	}
`

const MobileSelectButton = styled.div`
	width: 40px;
	max-width: 40px;
	height: 40px;
	max-height: 40px;
	background-color: ${({theme}) => theme.colors.dangerLight};
	border-radius: 4px;
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	right: 16px;
	//margin-bottom: 4px;
	svg {
		width: 14px;
		transform: rotate(90deg);
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: none;
	}
`

const MobileProjectSelectorWrapper = styled.div`
	position: absolute;
	z-index: 100;
	width: 100%;
	left: 0;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		display: none;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: none;
	}
`

const PaymentPurpose = styled.p`
	color: ${({theme}) => theme.colors.chilliRed};
	position: relative;
	opacity: 0;
	&:before {
		content: '';
		height: 2px;
		width: 100%;
		position: absolute;
		bottom: 5px;
		left: 0;
		background-color: ${({theme}) => theme.colors.chilliRed};
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		opacity: 1;
	}
	
	&.not-payment-page {
        color: ${({theme}) => theme.colors.richBlack};
		font-weight: 600;
		&:before {
			display: none;
		}
	}
`

const PaymentStepsContainer = styled.div`
	position: relative;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		position: relative;
		//background-color: ${({theme}) => theme.colors.white};
		height: 50vh;
		background-color: rgba(255,255,255,0.9);
		//opacity: 0.8;
		//z-index: 25;
		//background-color: red;
		
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: 75vh;
		position: relative;
		background-color: ${({theme}) => theme.colors.white};
	}
`

const PaymentStepsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
	//height: 75vh;
	//padding: 80px 0 8px 32px;
	&.scrollable {
		overflow: auto;
		max-height: calc(75vh - 80px - 10px);
		@media (min-width: 1536px) {
			max-height: calc(75vh - 130px - 10px);
		}
		&::-webkit-scrollbar {
			display: none;
		}
	}
	&.mobile-step-2, &.mobile-step-3{
		padding: 0 16px;
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		//background-color: rgba(255,255,255,0.9);
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: 75vh;
		//padding: 80px 8px 32px 32px;
		//padding: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
		padding: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)} 0 ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
		background-color: ${({theme}) => theme.colors.white};
		justify-content: space-between;
	}
	@media(min-width: 1536px) {
		padding: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)} 0 ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
		//padding: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
	}
`

const TabsWithContentWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	&.full-height {
		height: 100%;
	}
`

const TabsWrapper = styled.div`
	width: calc(100% - 32px);
	display: flex;
	background-color: ${({theme}) => theme.colors.white};
	padding: 32px 0;
	margin: 0 16px;
	flex-direction: row;
	justify-content: center;
	column-gap: 16px;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		background-color: transparent;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 100%;
		display: flex;
		background-color: transparent;
		justify-content: flex-start;
		column-gap: 0;
		padding: 0;
		margin: 0;
		margin-bottom: -1px;
	}
`

const SingleTabWrapper = styled.div`
	width: 142px;
	position: relative;
	height: 45px;
	border-radius: 54px;
	border: 1px solid ${({theme}) => theme.colors.richBlack};
	color: ${({theme}) => theme.colors.richBlack};
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	transition: color 0.15s ease-in-out, border 0.15s ease-in-out;
	box-sizing: border-box;
	cursor: pointer;
	overflow: hidden;
	p {
		position: relative;
		z-index: 2;
		text-transform: uppercase;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			text-transform: none;
		}
	}
	 &.active {
	 	color: ${({theme}) => theme.colors.white};
		 border-color: transparent;
		 transition: color 0.3s ease-in-out, border 0.3s ease-in-out 0.3s;
	 }
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: min(50%, 300px);
		height: ${getCssSizeValue(66, BREAKPOINTS.DESKTOP)};
		border-radius: 0;
		border: 1px solid ${({theme}) => theme.colors.richBlack};
		//border-bottom-width: 0;
		overflow: initial;
	}
	&:hover:not(&.active) {
		transition: border 0.15s ease-in-out, background 0.15s ease-in-out;
		border: 3px solid ${({theme}) => theme.colors.chilliRed};
		background-color: rgba(228, 31, 19, 0.10);
	}
`

const AnimatedBackground = styled(motion.div)`
	position: absolute;
	top: -1px;
	left: -1px;
	z-index: 0;
	height: calc(100% + 2px);
	width: calc(100% + 2px);
	background: ${({theme}) => theme.colors.chilliRed};
`

const TabsContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	//row-gap: 40px;
	padding: 0;
	height: 100%; 
	background-color: ${({theme}) => theme.colors.white};
	//background-color: rebeccapurple;
	&.small-gap {
		row-gap: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	}
	&.has-border {
		border: 1px solid ${({theme}) => theme.colors.richBlack};
		border-top-width: 0px;
		padding: 0;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding: 56px 32px 40px 16px;
			border: 1px solid ${({theme}) => theme.colors.richBlack};
		}
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		//background-color: rgba(255,255,255,0.9);
		background-color: transparent;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 100%;
		display: flex;
		flex-direction: column;
		//row-gap: 40px;
		row-gap: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)};
		padding: 0 32px 40px 16px;
		height: 100%;
		background-color: transparent;
		&.small-gap {
			row-gap: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		}
	}
`

const AmountButtonsWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	column-gap: 0;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		column-gap: 16px;
	}
`

const SingleAmountButton = styled.div`
	width: ${({ $numberOfItems }) => `calc(100% / ${ $numberOfItems })`};
	border-radius: 0;
	border: 1px solid ${({theme}) => theme.colors.richBlack};
	font-weight: ${({ theme }) => theme.fontWeight.bold}!important;
	color: ${({theme}) => theme.colors.richBlack};
	background-color: transparent;
	height: 48px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	transition: all .15s ease-in-out;
	cursor: pointer;
	overflow: hidden;
	position: relative;
	&.custom {
		overflow: initial;
	}
	&.active {
		background-color: ${({theme}) => theme.colors.chilliRed};
		color: ${({theme}) => theme.colors.white};
		border: none;
		transition: all .3s ease-in-out;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 180px;
		height: ${getCssSizeValue(66, BREAKPOINTS.DESKTOP)};
		border-radius: 56px;
	}
	&:hover:not(&.active) {
		transition: border 0.15s ease-in-out, background 0.15s ease-in-out;
		border: 3px solid ${({theme}) => theme.colors.chilliRed};
		background-color: rgba(228, 31, 19, 0.10);
	}
`

const AmountInput = styled.input`
	width: 100%;
	height: 100%;
	font-weight: ${({ theme }) => theme.fontWeight.bold};
	text-align: center;
	border: none;
	background-color: transparent;
	outline: none;
	-moz-appearance: textfield;
	transition: all .3s ease-in-out;
	&::placeholder {
		font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
		font-weight: ${({theme}) => theme.fontWeight.bold};
		font-family: ${({theme}) => theme.fontFamily.bornaFont};
        line-height: normal;
        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            font-size: ${getFontSize(24, BREAKPOINTS.TABLET)};
            line-height: ${getFontSize(43.2, BREAKPOINTS.TABLET)};
        }
        @media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
            font-size: ${getFontSize(24, BREAKPOINTS.DESKTOP)};
            line-height: ${getFontSize(43.2, BREAKPOINTS.DESKTOP)};
        }
		color: ${({ theme }) => theme.colors.richBlack};
		text-align: center;
		opacity: 1;
	}
	&.white {
		color: ${({theme}) => theme.colors.white};
		&::placeholder {
			color: ${({theme}) => theme.colors.white};
		}
	}
	&.dark-blue {
		color: ${({theme}) => theme.colors.richBlack};
		&::placeholder {
			color: ${({theme}) => theme.colors.richBlack};
		}
	}
	&.focus {
		&::placeholder {
			color: transparent;
		}
	}
	&.currency-translate {
		padding-right: 32px;
	}

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

const AmountInputWrapper = styled.div`
	position: relative;
	height: 100%;
	cursor: pointer;
	background-color: transparent;
	transition: all .3s ease-in-out;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        border-radius: 56px;
    }
	&.active {
		background-color: ${({theme}) => theme.colors.chilliRed};
		color: ${({theme}) => theme.colors.white};
		border: none;
		transition: all .3s ease-in-out;
	}
`;

const AmountValidationErrorTextWrapper = styled.div`
	position: absolute;
	bottom: -56px;
	left: 0;
	width: 100%;
	color: ${({theme}) => theme.colors.chilliRed};
	font-size: 12px;
	margin-top: 4px;
	font-weight: ${({theme}) => theme.fontWeight.regular};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		bottom: -50px;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		bottom: -30px;
		left: unset;
		right: 0;
		width: 200px;
		text-align: right;
	}
	@media(min-width: 1440px) and (orientation: landscape) {
		bottom: -50px;
		left: 0;
		right: unset;
		text-align: left;
		width: 100%;
	}
`

const InvisibleDivForUnit = styled.div`
	position: absolute;
	background-color: transparent;
	z-index: 50;
	top: 0;
	width: 50%;
	max-width: calc(100% - 15px);
	height: 100%;
	cursor: pointer;
	span {
		position: absolute;
		font-weight: ${({theme}) => theme.fontWeight.bold};
		top: calc(50% + 1px);
		transform: translateY(-50%);
		right: -30px;
	}
	
	&.hidden{
		visibility: hidden;
	}
`;

const AmountDescriptionAndPictogramWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 48px 20px 48px 36px;
	column-gap: 16px;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		//padding-left: 24px;
		padding: 0 0 0 24px;
		column-gap: 40px;
	}
`

const AmountDescription = styled.div`
	max-width: calc(100% - ${getCssSizeValue(80, BREAKPOINTS.MOBILE)} - 16px);
	font-weight: ${({theme}) => theme.fontWeight.regular}!important;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		max-width: calc(100% - 150px - 40px);
	}
`

const AmountPictogramWrapper = styled.div`
	width: ${getCssSizeValue(80, BREAKPOINTS.MOBILE)};
	img {
		width: 100%;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: ${getCssSizeValue(150, BREAKPOINTS.DESKTOP)};
	}
`

const ButtonIconWrapper = styled.div`
	height: 24px;
	//height: 14px;
	width: 24px;
	//width: 14px;
`

const CounterContainer = styled.div`
	min-width: 80px;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		min-width: 158px;
		&.step-1 {
			min-width: 158px;
		}
		&.step-3 {
			min-width: 158px;
		}
	}
`

const StyledStepCounter = styled.div`
	width: ${getCssSizeValue(60, BREAKPOINTS.MOBILE)};
	height: ${getCssSizeValue(60, BREAKPOINTS.MOBILE)};
	background-color: ${({theme}) => theme.colors.platinum};
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	&.back {
		cursor: pointer;
	}
	p {
		font-weight: ${({theme}) => theme.fontWeight.regular};
	}
	span.current {
		color: ${({theme}) => theme.colors.chilliRed};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: ${getCssSizeValue(100, BREAKPOINTS.DESKTOP)};
		height: ${getCssSizeValue(100, BREAKPOINTS.DESKTOP)};
	}
	@media (min-width: 1536px) {
		width: ${getCssSizeValue(122, BREAKPOINTS.DESKTOP)};
		height: ${getCssSizeValue(122, BREAKPOINTS.DESKTOP)};
	}
`

const MobileImagesContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: red;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		display: none;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: none;
	}
`

const SingleMobileImageWrapper = styled.div`
	width: 100%;
`

const ImagesContainer = styled.div`
	display: none;
	flex-direction: column;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		display: flex;
		position: relative;
		z-index: -1;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: flex;
		z-index: unset;
		position: unset;
	}
	
`

const SinglePaymentImageContainer = styled(GridContainer)`
	//position: relative;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		padding-top:${getCssSizeValue(150, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-top: ${getCssSizeValue(200, BREAKPOINTS.DESKTOP)};
	}
	@media( min-width: 1536px) {
		padding-top: ${getCssSizeValue(150, BREAKPOINTS.DESKTOP)};
	}
	&.not-payment-page {
		@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
			padding-top: ${getCssSizeValue(150, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding-top: ${getCssSizeValue(56, BREAKPOINTS.DESKTOP)};
		}
	}
	&.hidden {
		display: none;
	}
`


const FirstBlankModuleContent = styled.div`
	height: auto;
	cursor: pointer;
	background-color: ${({theme})=> theme.colors.antiflashWhite};
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		height: 75vh;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: 75vh;
	}
`

const ImageWrapper = styled.div`
	height: 75vh;
	cursor: pointer;
	&.mobile {
		height: ${getCssSizeValue(200, BREAKPOINTS.MOBILE)};
		@media(max-height: 700px) and (max-width: 1024px) {
			display: none;
		}
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		height: 50vh;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: 75vh;
		position: relative;
		.action-button {
			opacity: 1;
			transition: opacity 0.3s ease-in-out;
		}
		&:hover {
			.arrow-button-container {
				//width: auto;
				transition: border-radius 0.3s ease-in-out;
				border-radius: 0 8px 8px 0;
			}
			.arrow-button-text {
				transition: transform 0.3s ease-in-out, border-radius 0.3s ease-in-out;
				transform: scaleX(1) translateX(-30px);
				border-radius: 8px 0 0 8px;
			}
			.action-button {
				opacity: 1;
				transition: opacity 0.3s ease-in-out;
			}
		}
	}
	.image {
		height: 100%;
	}
`

const CustomCheckboxContainer = styled.div`
	margin-top: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-top: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-top: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
	}
`

const ProviderIcon = styled.div`
	width: 100%;
	height: 100%;
	.image {
		height: 100%;
		img{
			object-position: left center !important;
		}
	}
`

// Form
const StyledInputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
	row-gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	padding: 0 ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        width: ${getCssSizeValue(605, BREAKPOINTS.DESKTOP)};
		row-gap: ${getCssSizeValue(20, BREAKPOINTS.DESKTOP)};
		padding: 0;
    }
	@media(min-width: 1536px) {
		row-gap: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	}
	&.scrollable {
		//max-height: 300px;
		//overflow-y: auto;
		//&::-webkit-scrollbar {
		//	display: none;
		//}
	}
`;

const PaymentProvidersWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	flex-wrap: wrap;
	padding-left: 16px;
	//margin-top: 20px;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-left: 0;
	}
`

const SinglePaymentProvider = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border: 1px solid ${({theme}) => theme.colors.antiflashWhite};
	height: ${getCssSizeValue(65, BREAKPOINTS.MOBILE)};
	aspect-ratio: 1 !important;
	padding: 0 ${getCssSizeValue(10, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		// height: ${getCssSizeValue(132, BREAKPOINTS.DESKTOP)};
        height: ${getCssSizeValue(132, BREAKPOINTS.DESKTOP)};
		padding: ${getCssSizeValue(40, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(13, BREAKPOINTS.DESKTOP)};
	}
	img {
		//width: 100px;
		opacity: 0.3;
	}
	&.active {
		border: 2px solid ${({theme}) => theme.colors.chilliRed};
		img {
			opacity: 1;
		}
	}
`

const SingleRadioButton = styled.input`
	color: ${({ theme }) => theme.colors.chilliRed};
	&.hidden {
		opacity: 0;
	}
`;

const StyledDescriptionText = styled.div`
	color: ${({theme}) => theme.colors.richBlack};
	padding: 0 ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	&.top-info {
		padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding: 0;
		}
	}
	&.more-data {
		margin-top: 8px;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-top: 24px;
		}
	}
	span.highlight, em {
		color: ${({theme}) => theme.colors.chilliRed};
		font-weight: ${({theme}) => theme.fontWeight.bold};
		position: relative;
		cursor: pointer;
		font-style: normal;
		&:before {
			content: '';
			position: absolute;
			bottom: 3px;
			width: 100%;
			height: 1px;
			background-color: ${({theme}) => theme.colors.chilliRed};
		}
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: 0;
	}
`

const BottomNavigatingContainer = styled.div`
	width: calc(100% - 32px);
	margin: 0 16px;
	background-color: ${({theme}) => theme.colors.white};
	padding: 32px 8px 8px;
	//position: absolute;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	//padding: 0;
	align-items: center;
	&.mobile-step-2, &.mobile-step-3 {
		width: 100%;
		margin: 0;
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		background-color: transparent;
		width: 100%;
		position: absolute;
		bottom: 8px;
		left: 0;
		margin: 0;
		padding: 0 8px 0 16px;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: flex;
		width: 100%;
		position: absolute;
		bottom: 8px;
		left: 0;
		margin: 0;
		padding: 0 8px 0 16px;
	}
`

const BackButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	cursor: pointer;
	&.step-1 {
		pointer-events: none;
		opacity: 0;
	}
	p {
		display: none;
		color: ${({theme}) => theme.colors.chilliRed};
		font-size: ${getFontSize(18, BREAKPOINTS.MOBILE)};
		line-height:${getFontSize(21.6, BREAKPOINTS.MOBILE)};
		font-weight: ${({theme}) => theme.fontWeight.bold};
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			display: block;
		}
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		min-width: 150px;
	}
`

const ArrowWrapper = styled.div`
	height: 40px;
	width: 40px;
	margin-right: 8px;
	> div {
		width: 100%;
		height: 100%;
	}
	.icon {
		max-width: 100px;
		max-height: 100px;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: 40px;
		width: 40px;
		margin-right: 8px;
	}
	svg {
		width: 100%;
		height: 100%;
	}
`

const StyledTwoInputsInRowWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	column-gap: 24px;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		column-gap: 40px;
	}
`

const Summary = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	position: relative;
	padding: 32px 16px 0;
	&.fixed {
		gap: 8px;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		//gap: 40px;
		gap: 24px;
		padding: 0;
	}
	.label {
		//min-width: 120px;
		text-align: left;
		// @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		// 	min-width: 150px;
		// }
	}

	.value {
		text-align: left;
		font-weight: ${({theme}) => theme.fontWeight.lack};
		color: ${({theme}) => theme.colors.chilliRed};
	}
`

const SecureFormWrapper = styled.div`
	//position: absolute;
	//top: 0;
	//right: 0;
	display: none;
	z-index: 2;
	&.visible {
		display: block;
		padding: 0 16px;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding: 0;
		}
	}
}
	.payu-card-field {
		margin-bottom: 15px;
	}
	.response-error {
		color: red;
	}
	.response-success {
		color: green;
	}
	.payu-card-field {
		margin-bottom: 15px;
	}
	.response-error {
		color: red;
	}
	.response-success {
		color: green;
	}
	.container * {
		font-family: ${({theme}) => theme.fontFamily.StrawfordFont}!important;
		font-size: 14px;
		color: ${({theme}) => theme.colors.richBlack};
	}
	
	

	

	button#tokenizeButton {
		border: none;
		background: ${({theme}) => theme.colors.chilliRed};
		border-radius: 6px;
		padding: 8px 15px;
		//margin: 10px auto;
		cursor: pointer;
		color: ${({theme}) => theme.colors.white}!important;
	}

	.response-success {
		color: #438f29;
	}

	.response-error {
		color: #990000;

`

const SingleSummaryRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
    column-gap: ${getCssSizeValue(10, BREAKPOINTS.MOBILE)};
	.value {
		font-weight: ${({theme}) => theme.fontWeight.black};
	}
    @media (min-width: ${({theme}) => theme.breakpoints.desktop}px) and (orientation: landscape) {
        column-gap: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
    }
`

const FixedPayloadLiveSummary = styled.div`
	display: none;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	width: 400px;
	background-color: rgba(0,0,0,0.74);
	color: ${({theme}) => theme.colors.white};
	position: fixed;
	z-index: 10;
	top: 150px;
	right: 50px;
	padding: 32px;
	@media(min-width: 1024px) {
		//display: flex;
		display: none;
	}
`

const ShowInfoModalText = styled.p`
	font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
	line-height: ${getFontSize(21, BREAKPOINTS.MOBILE)};
	font-weight: ${({theme}) => theme.fontWeight.bold}!important;
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
		line-height: normal;
	}
	@media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
		font-weight: ${({theme}) => theme.fontWeight.medium};
		font-size: ${getFontSize(20, BREAKPOINTS.DESKTOP)};
		line-height: ${getFontSize(30, BREAKPOINTS.DESKTOP)};
	}
	span {
		color: ${({theme}) => theme.colors.chilliRed};
		position: relative;
		cursor: pointer;
		&:before {
			content: '';
			position: absolute;
			bottom: 3px;
			width: 100%;
			height: 1px;
			background-color: ${({theme}) => theme.colors.chilliRed};
		}	
	} 
`

const Payment = ({ data }) => {
	// CMS Data
	// const paymentsData = data?.choosePayments || '';
	const paddings = getPaddingsClassFromData(data);
	const paymentsDataBlock = data?.paymentModuleType || '';
	const paymentsData = paymentsDataBlock?.choosePayment || [];
	const tempPay = paymentsData;
	const globalPckPayment = data?.globalPckPayment || '';
	const globalPckPaymentProjectTemp = globalPckPayment?.linkToGlobalPckPayment || {};
	const globalPckPaymentProject = {...globalPckPaymentProjectTemp, id: getIdWithoutSpecialSymbols(globalPckPaymentProjectTemp?.id)}
	const globalPaymentRightBlocks = globalPckPayment?.globalPaymentRightBlocks || [];
	const router = useRouter();
	const globalPckPaymentModule = globalPckPayment?.moduleText || {};
	const [finalPaymentData, setFinalPaymentData] = useState(tempPay)
	const hasAddedObject = useRef(false);
	const [payOrigin, setPayOrigin] = useState('');
	const deviceTypeInfo = `${deviceTypeName?.toLowerCase()} | ${osName.toLowerCase()} | ${browserName?.toLowerCase()}`;
	const [posIdPayU, setPosIdPayU] = useState(process.env.PAYU_KEY);
	useEffect(() => {
		if (!hasAddedObject.current && globalPckPayment) {
			setFinalPaymentData((prevArray) => [globalPckPaymentProject, ...prevArray]);
			hasAddedObject.current = true;
		}
	}, []);
	const {asPath, locale} = useRouter();
	const { selectedOption } = useBranch();
	const isDesktop = useIsDesktop()
	const isTablet = useIsTablet();
	const isMobile = useIsMobile()
	// Globals
	const globals = useGlobals()
	const tabOneTimePayment = globals?.tabOneTimePayment || '';
	const tabRecurringPayment = globals?.tabRecurringPayment || '';
	const tabOneTimePaymentMobile = globals?.tabOneTimePaymentMobile || '';
	const tabRecurringPaymentMobile = globals?.tabRecurringPaymentMobile || '';
	const titleIPayFor = globals?.titleIPayFor || '';
	const buttonTextIPay = globals?.buttonTextIPay || '';
	const backButtonText = globals?.backButtonText || '';
	const paymentAmountValidationText = globals?.paymentAmountValidationText || '';
	const step2NamePlaceholder = globals?.step2NamePlaceholder || '';
	const step2SurnamePlaceholder = globals?.step2SurnamePlaceholder || '';
	const step2EmailPlaceholder = globals?.step2EmailPlaceholder || '';
	const step2StreetPlaceholder = globals?.step2StreetPlaceholder || '';
	const step2CityPlaceholder = globals?.step2CityPlaceholder || '';
	const step2ZipCodePlaceholder = globals?.step2ZipCodePlaceholder || '';
	const step2CountryPlaceholder = globals?.step2CountryPlaceholder || '';
	const step2PhonePlaceholder = globals?.step2PhonePlaceholder || '';
	const agreement = globals?.agreement || '';
	const weNeedYourDataText = globals?.weNeedYourDataText || '';
	const iWantMoreData = globals?.iWantMoreData || '';
	const summaryAmount = globals?.summaryAmount || '';
	const summaryPaymentType = globals?.summaryPaymentType || '';
	const summaryPaymentProvider = globals?.summaryPaymentProvider || '';
	const paymentMonthlyModalInfo = globals?.paymentMonthlyModalInfo || '';
	const paymentProviderErrorModalText = globals?.paymentProviderErrorModalText || '';
	const paymentMonthlyShowModalInfoText = globals?.paymentMonthlyShowModalInfoText || '';
	// showMonthlyInfoModal
	// showMonthlyPaymentTab
	// Payment Providers
	const payuLogoUrl = globals?.payuLogo?.url || '';
	const payuLogoWidth = globals?.payuLogo?.width || '';
	const payuLogoHeight = globals?.payuLogo?.height || '';
	const paypalLogoUrl = globals?.paypalLogo?.url || '';
	const paypalLogoWidth = globals?.paypalLogo?.width || '';
	const paypalLogoHeight = globals?.paypalLogo?.height || '';
	const stripeLogoUrl = globals?.stripeLogo?.url || '';
	const stripeLogoWidth = globals?.stripeLogo?.width || '';
	const stripeLogoHeight = globals?.stripeLogo?.height || '';

	// States
	const [currentIndex, setCurrentIndex] = useState(0);
	const [currentStep, setCurrentStep] = useState(1);
	const [currentAmountIndex, setCurrentAmountIndex] = useState(0);
	// const [activeTabIndex, setActiveTabIndex] = useState(0);
	const [activeTabIndex, setActiveTabIndex] = useState(1);
	const amountTabsKey = activeTabIndex === 0 ? "amountTabs" : "amountTabsMonthly";
	const [currentPrefixCountryCode, setCurrentPrefixCountryCode] = useState('PL')
	const [customAmount, setCustomAmount] = useState(0);
	const [customAmountFocus, setCustomAmountFocus] = useState(false);
	const [showMoreInputsStep2, setShowMoreInputsStep2 ] = useState(false);
	const [isChecked, setIsChecked] = useState(false);
	const [isOnceSubmitted, setIsOnceSubmitted] = useState(false);
	const [isMonthlyModalVisible, setIsMontlyModalVisible] = useState(false);
	const [isAmountValidationInfoShown, setIsAmountValidationInfoShown] = useState(false);
	const [isPaymentProviderError, setIsPaymentProviderError] = useState(false);
	// console.log(finalPaymentData);
	const [currentPaymentData, setCurrentPaymentData] = useState({
		inflectedWord: finalPaymentData?.[0]?.inflectedWord || '',
		amountTabs: finalPaymentData?.[0]?.amountTabs || '',
		amountTabsMonthly: finalPaymentData?.[0]?.amountTabsMonthly || '',
		imageUrl: finalPaymentData?.[0]?.image?.url || '',
		imageAlt: finalPaymentData?.[0]?.image?.alt || '',
		showMonthlyInfoModal: finalPaymentData?.[0]?.showMonthlyInfoModal || false,
		showMonthlyPaymentTab: finalPaymentData?.[0]?.showMonthlyPaymentTab || false,
		setMonthlyPaymentTabToDefault: finalPaymentData?.[0]?.setMonthlyPaymentTabToDefault || false,
	})
	const isPaymentPage = router.asPath.includes(PAGES.I_PAY)
	const getRouteFromSessionStorage = () => {
		const currentPath = sessionStorage.getItem('currentPath');
		return currentPath ? currentPath : null;
	};
	const [paymentPayload, setPaymentPayload] = useState({
		// groupId: 'pleo', // string
		projectId: 1, // number/LONG
		card : '', // string
		firstName: '', // string
		lastName: '', // string
		email: '', // string
		city: '', // string
		street: '', // string
		zipCode: '', // string
		country: 'PL', // string
		phoneNumberPrefix: '+48',
		phoneNumber: '', // string
		branch: selectedOption,
		// paymentType: 'PAYMENT', // SUBSCRIPTION OR PAYMENT
		paymentType: (currentPaymentData?.setMonthlyPaymentTabToDefault && currentPaymentData?.showMonthlyPaymentTab) ? 'SUBSCRIPTION' : 'PAYMENT', // SUBSCRIPTION OR PAYMENT
		// amount: currentPaymentData?.amountTabs?.[0]?.amountWithoutUnit || 0, // number/LONG
		amount: currentPaymentData?.[amountTabsKey]?.[0]?.amountWithoutUnit || 0, // number/LONG
		originalTimestamp: Date.now(), // Date
		// ewentualnie do dodania?
		currency: 'PLN',
		provider: 'PAYU', // payu || paypal || stripe
		// origin: payOrigin,
		origin: getRouteFromSessionStorage(),
		deviceType: deviceTypeInfo
	})
	const isAction = useIsWWDSingleAction()
	const CURRENCY = locale === LOCALES.PL ? 'zł' : 'PLN'
	// Refs and Hooks
	const wrapperRef = useRef();
	const paymentFormRef = useRef();
	const imagesContainerRef = useRef();
	const mobileProjectSelectorWrapperRef = useRef();
	const viewportWidth = useViewportWidth()
	const viewportHeight = useViewportHeight()
	const scroll = useScrollContext()

	// Functions
	const handleResetPayloadToInitial = () => {
		// setActiveTabIndex(0) // idziemy na zakładkę płatność jednorazowa
		setCurrentAmountIndex(0) // zaznaczamy pierwszy tab jako aktywną kwotę
		setCurrentStep(1) // wracamy do pierwszego kroku
		setCustomAmount(0) // zresetowanie customowej kwoty
		setCurrentPaymentData({ // ustawienie danych aktualnego projektu
			inflectedWord: finalPaymentData?.[currentIndex]?.inflectedWord || '',
			amountTabs: finalPaymentData?.[currentIndex]?.amountTabs || '',
			// amountTabs: finalPaymentData?.[currentIndex]?.[amountTabsKey] || '',
			imageUrl: finalPaymentData?.[currentIndex]?.image?.url || '',
			imageAlt: finalPaymentData?.[currentIndex]?.image?.alt || '',
			showMonthlyInfoModal: finalPaymentData?.[currentIndex]?.showMonthlyInfoModal || true,
			showMonthlyPaymentTab: finalPaymentData?.[currentIndex]?.showMonthlyPaymentTab || false,
			setMonthlyPaymentTabToDefault: finalPaymentData?.[currentIndex]?.setMonthlyPaymentTabToDefault || false,
		})
		setIsChecked(false)
		setIsOnceSubmitted(false)
		setCurrentPrefixCountryCode('PL');
		setIsAmountValidationInfoShown(false);
		setPaymentPayload({
			// groupId: 'pleo',
			projectId: finalPaymentData?.[currentIndex]?.paymentId || 1,
			card: '',
			firstName: '',
			lastName: '',
			email: '',
			city: '',
			street: '',
			zipCode: '',
			country: 'PL',
			phoneNumberPrefix: '+48',
			phoneNumber: '',
			branch: selectedOption,
			// paymentType: 'PAYMENT',
			paymentType: (finalPaymentData?.[currentIndex]?.setMonthlyPaymentTabToDefault && finalPaymentData?.[currentIndex]?.showMonthlyInfoModal) ? 'SUBSCRIPTION' : 'PAYMENT',
			amount: finalPaymentData?.[currentIndex]?.amountTabs?.[0]?.amountWithoutUnit || 0, // number/LONG
			// amount: currentPaymentData?.[amountTabsKey]?.[0]?.amountWithoutUnit || 0, // number/LONG
			originalTimestamp: Date.now(),
			currency: 'PLN',
			provider: 'PAYU', // payu || paypal || stripe
			// origin: payOrigin
			origin: getRouteFromSessionStorage(),
			deviceType: deviceTypeInfo
		})
	}
	const handleLoadSessionStorageDataIfExist = () => {
		const currentProjectId = finalPaymentData?.[currentIndex]?.id || '';
		const sessionStorageElement = sessionStorage.getItem(`paymentName-${currentProjectId}`);
		if (sessionStorageElement) {
			console.log('wczytuje dane...')
			const parsedSessionStorageData = JSON.parse(sessionStorageElement);
			setCurrentPaymentData({ // ustawienie danych aktualnego projektu
				inflectedWord: finalPaymentData?.[currentIndex]?.inflectedWord || '',
				// amountTabs: finalPaymentData?.[currentIndex]?.amountTabs || '',
				amountTabs: finalPaymentData?.[currentIndex]?.[parsedSessionStorageData.amountTabsKey] || '',
				imageUrl: finalPaymentData?.[currentIndex]?.image?.url || '',
				imageAlt: finalPaymentData?.[currentIndex]?.image?.alt || '',
				showMonthlyInfoModal: finalPaymentData?.[currentIndex]?.showMonthlyInfoModal || true,
				showMonthlyPaymentTab: finalPaymentData?.[currentIndex]?.showMonthlyPaymentTab || false,
				setMonthlyPaymentTabToDefault: finalPaymentData?.[currentIndex]?.setMonthlyPaymentTabToDefault || false,
			})
			setPaymentPayload({
				// groupId: parsedSessionStorageData.groupId,
				projectId: parsedSessionStorageData.projectId, // ta linijka powoduje ze jest nadane id dla PCK
				card: parsedSessionStorageData.card,
				firstName: parsedSessionStorageData.firstName,
				lastName: parsedSessionStorageData.lastName,
				email: parsedSessionStorageData.email,
				city: parsedSessionStorageData.city,
				street: parsedSessionStorageData.street,
				zipCode: parsedSessionStorageData.zipCode,
				country: parsedSessionStorageData.country,
				phoneNumberPrefix: parsedSessionStorageData.phoneNumberPrefix,
				phoneNumber: parsedSessionStorageData.phoneNumber,
				paymentType: parsedSessionStorageData.paymentType,
				amount: parsedSessionStorageData.amount,
				branch: selectedOption,
				// amount: parsedSessionStorageData.isCustomAmount ? parsedSessionStorageData.customAmount : parsedSessionStorageData.amount,
				originalTimestamp: Date.now(),
				currency: 'PLN',
				provider: 'PAYU',
				deviceType: deviceTypeInfo,
				// origin: payOrigin
				origin: getRouteFromSessionStorage()
			})
			setActiveTabIndex(parsedSessionStorageData.activeTabIndex)
			setCurrentStep(parsedSessionStorageData.maxStep)
			setCurrentAmountIndex(parsedSessionStorageData.amountIndex)
			setCurrentPrefixCountryCode(parsedSessionStorageData.currentPrefixCountryCode)
			if(parsedSessionStorageData.isCustomAmount) {
				setCustomAmount(parsedSessionStorageData.amount)
			} else {
				setCustomAmount(0)
			}
			// setCurrentPaymentData({ // ustawienie danych aktualnego projektu
			// 	inflectedWord: paymentsData?.[currentIndex]?.inflectedWord || '',
			// 	amountTabs: paymentsData?.[currentIndex]?.amountTabs || '',
			// 	// amountTabs: paymentsData?.[currentIndex]?.[parsedSessionStorageData.amountTabsKey] || '',
			// 	imageUrl: paymentsData?.[currentIndex]?.image?.url || '',
			// 	imageAlt: paymentsData?.[currentIndex]?.image?.alt || '',
			// })
		} else {
			console.log('tworze nowy zestaw danych')
			// nie ma danych więc muszę zresetować do pierwszego kroku, płatności jednorazowej
			setCurrentStep(1)
			const tabFinalIndex = (finalPaymentData?.[currentIndex]?.setMonthlyPaymentTabToDefault && finalPaymentData?.[currentIndex]?.showMonthlyPaymentTab) ? 1 : 0;
			// handleTabClick(0);
			handleTabClick(tabFinalIndex);
			setCurrentAmountIndex(0)
			setCustomAmount(0)
			handleResetPayloadToInitial();
			// console.log('na tym etapie active tab index to ' + activeTabIndex);
			// console.log('na tym etapie tab final index to ' + tabFinalIndex);
			handleChangeCurrentProjectSessionStorageData(tabFinalIndex)
		}
	}

	const handleChangeCurrentProjectSessionStorageData = (index = 0) => {
		const currentProjectId = finalPaymentData?.[currentIndex]?.id || '';
		sessionStorage.setItem(`paymentName-${currentProjectId}`, JSON.stringify({
			id: currentProjectId,
			maxStep: currentStep,
			// activeTabIndex: activeTabIndex,
			activeTabIndex: index,
			amountIndex: currentAmountIndex,
			amountTabsKey: amountTabsKey,
			// isCustomAmount: currentAmountIndex === currentPaymentData.amountTabs.length - 1,
			isCustomAmount: currentAmountIndex === currentPaymentData[amountTabsKey]?.length - 1,
			// isCustomAmount: false,
			customAmount: customAmount,
			// title: paymentsData?.[currentIndex]?.inflectedWord || '',
			title: finalPaymentData?.[currentIndex]?.inflectedWord || '',
			// groupId: paymentPayload?.groupId || '',
			projectId: finalPaymentData?.[currentIndex]?.paymentId || 1,
			firstName: paymentPayload?.firstName || '',
			lastName: paymentPayload?.lastName || '',
			email: paymentPayload?.email || '',
			city: paymentPayload?.city || '',
			street: paymentPayload?.street || '',
			zipCode: paymentPayload?.zipCode || '',
			country: paymentPayload?.country || '',
			currentPrefixCountryCode: currentPrefixCountryCode,
			phoneNumberPrefix: paymentPayload?.phoneNumberPrefix || '',
			phoneNumber: paymentPayload?.phoneNumber || '',
			paymentType: paymentPayload?.paymentType || 'PAYMENT',
			amount: paymentPayload.amount,
		}))
	}

	const createNewSessionStorageItem = (id) => {
		const sessionStorageElement = sessionStorage.getItem(id);
		if(!sessionStorageElement) {
			sessionStorage.setItem(`paymentName-${id}`, JSON.stringify({
				id: id,
				name: 'payment name',
				amount: 170
			}))
		}
	}

	const handleSetProvider = (providerName) => {
		setPaymentPayload((prevData) => ({ ...prevData, ["provider"]: providerName }))
		if(providerName !== 'PAYU') {
			setPaymentPayload((prevData) => ({ ...prevData, ["card"]: '' }))
		}
	}
	const handleAmountClick = (i) => {
		setCurrentAmountIndex(i);
		const amount = currentPaymentData?.amountTabs?.[i]?.amountWithoutUnit || 0;
		setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: amount }));
		setIsAmountValidationInfoShown(false);
	}

	const handleChangeProject = (i) => {
		setCurrentIndex(i);
		document?.getElementById('amount-input')?.blur();
	}
	const handleCurrentProjectChange = (i) => {
		setCurrentStep(1)
		setCurrentIndex(i)
		handleTabClick(0);
		setCurrentAmountIndex(0)
		setCustomAmount(0)
		setCurrentPaymentData({
			inflectedWord: paymentsData?.[i]?.inflectedWord || '',
			// amountTabs: paymentsData?.[i]?.amountTabs || '',
			amountTabs: paymentsData?.[i]?.[amountTabsKey] || '',
			imageUrl: paymentsData?.[i]?.image?.url || '',
			imageAlt: paymentsData?.[i]?.image?.alt || '',
		})
		const amount = paymentsData?.[i]?.[amountTabsKey]?.[0]?.amountWithoutUnit || 0;
		setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: amount }))
		document?.getElementById('amount-input')?.blur();
	}

	const tokenize = useRef(() => {})
	const handleSetCard = (card) => setPaymentPayload((prevData) => ({
		...prevData,
		card
	}))

	const handleSendPaymentRequest = async (e) => {
		e.preventDefault();
		const {
			groupId,
			projectId,
			card,
			firstName,
			lastName,
			email,
			city,
			street,
			zipCode,
			country,
			phoneNumberPrefix,
			phoneNumber,
			paymentType,
			amount,
			branch,
			provider,
			originalTimestamp,
			origin,
			deviceType
		} = paymentPayload;
		// console.log(card, provider, paymentType, tokenize, isFunction(tokenize.current));
		let finalCard = card
		if(provider === 'PAYU' && paymentType === 'SUBSCRIPTION'){
			const tokenizedCard = await tokenize.current()
			handleSetCard(tokenizedCard)
			finalCard = tokenizedCard
		}
		const form = new FormData();
		// form.append('groupId', groupId)
		form.append('projectId', projectId)
		form.append('card', finalCard)
		form.append('firstName', firstName)
		form.append('lastName', lastName)
		form.append('email', email)
		form.append('city', city)
		form.append('street', street)
		form.append('zipCode', zipCode)
		form.append('country', country)
		form.append('phoneNumberPrefix', phoneNumberPrefix)
		form.append('phoneNumber', phoneNumber)
		form.append('paymentType', paymentType)
		form.append('amount', amount)
		form.append('branch', branch)
		form.append('originalTimestamp', originalTimestamp)
		form.append('origin', origin)
		form.append('deviceType', deviceType)

		try {
			const API_URL = `${process.env.NEXT_PAYMENT_URL}${provider}/checkout`
			// const response = await fetch(process.env.NEXT_PAYMENT_STRIPE_URL, {
			const response = await fetch(API_URL, {
				method: 'POST',
				body: form,
				headers: {
				// 	'Content-Type': 'application/json',
					'X-Organization': process.env.X_ORGANIZATION_HEADER,
				},
				// body: JSON.stringify(paymentPayload),
			});
			if (response.status === 200) {
				response.text().then((res) =>{
					window.location.href = res;
					console.log(res)
				})
				console.log(response)
				// window.location.href = 'https://example.com/success';
				// alert('płatność się powiodła')
			} else {
				// alert('płatność się nie powiodła')
				setIsPaymentProviderError(true)
			}
		} catch (err) {
			console.log(err);
		}
	}

	const getPayUPosIdForProject = async (projectID) => {
		const API_URL = `${process.env.NEXT_PAYMENT_URL}projects/${projectID}/validate`
		const response = await fetch(API_URL, {
			method: 'GET',
			headers: {
				'X-Organization': process.env.X_ORGANIZATION_HEADER,
			},
		});
		if (response.status === 200) {
			response.text().then((res) =>{
				setPosIdPayU(res);
				setCurrentStep(3);
			})
		}
	}
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setPaymentPayload((prevData) => ({ ...prevData, [name]: value }));
	};

	const handlePhoneNumberInputChange = (e) => {
		const val = e.target.value;
		const regex = /^[0-9-+() ]*$/;
		if (regex.test(val)) {
			setPaymentPayload((prevData) => ({...prevData, ["phoneNumber"]: val}));
		}
	};

	const handleCountryChange = (selectedOption) => {
		setPaymentPayload((prevData) => ({ ...prevData, country: selectedOption.value })); // country iso code
		// setPaymentPayload((prevData) => ({ ...prevData, country: selectedOption.label })); // country name in current locale
	};
	const handleProjectChange = (selectedOption) => {
		setCurrentIndex(selectedOption.index);
		// setPaymentPayload((prevData) => ({ ...prevData, country: selectedOption.value })); // country iso code
		// setPaymentPayload((prevData) => ({ ...prevData, country: selectedOption.label })); // country name in current locale
	};

	const handlePhonePrefixChange = (selectedOption) => {
		setPaymentPayload((prevData) => ({ ...prevData, phoneNumberPrefix: selectedOption.prefix })); // country iso code
		setCurrentPrefixCountryCode(selectedOption.value);
		// setPaymentPayload((prevData) => ({ ...prevData, phoneNumberPrefix: selectedOption.value })); // country iso code
		// setPaymentPayload((prevData) => ({ ...prevData, country: selectedOption.label })); // country name in current locale
	};
	const handleButtonClick = () => {
		if(currentStep <= 2) {
			setCurrentStep(currentStep + 1);
		}
	}

	const validateCustomAmount = () => {
		setIsAmountValidationInfoShown(true)
	}
	const handleBackButtonClick = () => {
		if(currentStep > 0) {
			setCurrentStep(currentStep - 1);
		}
	}

	const handleTabClick = (i) => {
		setActiveTabIndex(i)
		setPaymentPayload((prevData) => (
			{ ...prevData,
				["paymentType"]: i === 1 ? 'SUBSCRIPTION' : 'PAYMENT',
				// ["amount"]: paymentsData?.[currentIndex]?.[amountTabsKey]?.[currentAmountIndex]?.amountWithoutUnit || 0,
				// ["amount"]: currentPaymentData?.amountTabs?.[i]?.amountWithoutUnit || 0,
				// ["amount"]: currentPaymentData?.amountTabs?.[currentAmountIndex]?.amountWithoutUnit || 0
			}
		))
		// setActiveTabIndex(i)
	}

	const showMoreInputs = () => {
		setShowMoreInputsStep2(true)
	}
	const scrollToPayment = (id) => {
		const element = document.getElementById(id);
		scroll.scrollTo({
			behavior: 'smooth',
			top: window.innerHeight + (element.offsetTop - element.scrollTop + element.clientTop),
		});
	}

	const scrollToMobilePaymentContainer = (id) => {
		const element = document.getElementById(id);
		scroll.scrollTo({
			behavior: 'smooth',
			top: element.offsetTop,
		});
	}

	const setCurrentProjectOnMobileFromHash = (hash) => {
		const item = finalPaymentData.findIndex((obj) => getIdWithoutSpecialSymbols(obj.id) === hash);
		if(item !== -1) {
			setCurrentIndex(item);
			scrollToMobilePaymentContainer('payment-container');
		}
	}

	const handleSubmitFormData = (e) => {
		e.preventDefault();
		setIsOnceSubmitted(true)

		if (!validateInput(paymentPayload.firstName) || !validateInput(paymentPayload.lastName) || !validateEmailInput(paymentPayload.email)) return

		if((showMoreInputsStep2 && validatePhoneNumber(paymentPayload.phoneNumber) && validateZipCode(paymentPayload.zipCode)) || !showMoreInputsStep2){
			getPayUPosIdForProject(paymentPayload.projectId).then(() => {})
		}
	}

	const handleCheckboxToggle = (checked) => {
		setIsChecked(checked);
	};

	const handleCustomAmount = (e) => {
		setCustomAmount(e.target.value);
		updateUnitSuffix()
		setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: e.target.value }))
	}

	const handleCustomAmountFocus = (key) => {
		setCurrentAmountIndex(key);
		setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: customAmount }))
		document.getElementById('amount-input').focus();
	}

	const updateUnitSuffix = () => {
		setTimeout(() => {
			const inputEl = document.getElementById('amount-input');
			const unitEl = document.getElementById('invisible-div');
			const shift = (inputEl?.value?.length + 1) * 5.8 || 27;
			if(unitEl) {
				unitEl.style.width = 'calc(50% + ' + shift + 'px)';
			}
		}, 10)
	};

	const handleClosePaymentProviderErrorModal = () => {
		setIsPaymentProviderError(false);
	}

	// Validation
	const validateEmail = (email) => {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	};

	const validateZipCode = (zipCode) => {
		return postalCodes.validate(paymentPayload.country, zipCode) === true;
	}
	const validatePhoneNumber = (phoneNumber) => {
		const phoneNumberWithPrefix = `${paymentPayload.phoneNumberPrefix}${phoneNumber}`;
		const {isValid} = phone(phoneNumberWithPrefix, {
			country: currentPrefixCountryCode,
			validateMobilePrefix: true
		})
		return isValid;
	}

	const validationForNumbers = (e) => {
		let key = e.keyCode || e.which;
		key = String.fromCharCode(key);
		let regex = /[0-9]|\./;
		if (!regex.test(key)) {
			e.returnValue = false;
			if (e.preventDefault) e.preventDefault();
		}
	}

	// Effects
	// useEffect(() => {
	// 	const savedPath = getRouteFromSessionStorage();
	// 	setPayOrigin(savedPath);
	// 	setPaymentPayload((prevData) => ({...prevData, ["origin"]: savedPath}));
	// },[asPath,setPayOrigin])

	useEffect(() => {
		if (!router.isReady) return;
		if (isDesktop) {
			const {hash} = window.location;
			if (hash) {
				const id = hash.replace("#", "");
				setTimeout(() => {
					const element = document.getElementById(id);
					if (element) {
						element.scrollIntoView({behavior: "smooth", block: "start"});
					}
				}, 300);
			}
		}
	}, [router.isReady, isDesktop]);

	useEffect(() => {
		if(isMobile && router.isReady) {
			const hash = asPath.split('#')[1];
			if(hash) {
				setCurrentProjectOnMobileFromHash(hash)
			}
		}
	}, [asPath, isMobile, router.isReady, finalPaymentData])

	useEffect(() => {
		if(hasAddedObject.current) {
			handleChangeCurrentProjectSessionStorageData(activeTabIndex)
		}
	}, [paymentPayload, activeTabIndex])

	useEffect(() => {
		handleLoadSessionStorageDataIfExist()
	}, [currentIndex, selectedOption, finalPaymentData]);


	useEffect(() => {
		// setCurrentPaymentData((prevData) => ({...prevData, ["amountTabs"] : paymentsData?.[currentIndex]?.[amountTabsKey] || ''}))
		// setCurrentAmountIndex(currentAmountIndex)
		setCurrentPaymentData({ // ustawienie danych aktualnego projektu
			inflectedWord: finalPaymentData?.[currentIndex]?.inflectedWord || '',
			// amountTabs: finalPaymentData?.[currentIndex]?.amountTabs || '',
			// amountTabs: finalPaymentData?.[currentIndex]?.[amountTabsKey] || '',
			amountTabs: finalPaymentData?.[currentIndex]?.[amountTabsKey] || '',
			amountTabsMonthly: finalPaymentData?.[currentIndex]?.[amountTabsKey] || '',
			imageUrl: finalPaymentData?.[currentIndex]?.image?.url || '',
			imageAlt: finalPaymentData?.[currentIndex]?.image?.alt || '',
			showMonthlyInfoModal: finalPaymentData?.[currentIndex]?.showMonthlyInfoModal || true,
			showMonthlyPaymentTab: finalPaymentData?.[currentIndex]?.showMonthlyPaymentTab || false,
			setMonthlyPaymentTabToDefault: finalPaymentData?.[currentIndex]?.setMonthlyPaymentTabToDefault || false,
		})
		// if(currentAmountIndex !== currentPaymentData.amountTabs.length - 1) {
		if(currentAmountIndex !== currentPaymentData[amountTabsKey]?.length - 1) {
			const amount = finalPaymentData?.[currentIndex]?.[amountTabsKey]?.[currentAmountIndex]?.amountWithoutUnit || 0;
			setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: amount }))
		}
		else {
			const amount = finalPaymentData?.[currentIndex]?.[amountTabsKey]?.[currentAmountIndex]?.amountWithoutUnit || 0;
			setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: amount }))
		}
	},[activeTabIndex, finalPaymentData])
	// useEffect(() => {
	// 	setCurrentAmountIndex(0);
	// 	setCurrentPaymentData({
	// 		inflectedWord: paymentsData?.[currentIndex]?.inflectedWord || '',
	// 		// amountTabs: paymentsData?.[currentIndex]?.amountTabs || '',
	// 		amountTabs: paymentsData?.[currentIndex]?.[amountTabsKey] || '',
	// 		imageUrl: paymentsData?.[currentIndex]?.image?.url || '',
	// 		imageAlt: paymentsData?.[currentIndex]?.image?.alt || ''
	// 	})
	// 	const amount = paymentsData?.[currentIndex]?.[amountTabsKey]?.[0]?.amountWithoutUnit || 0;
	// 	setPaymentPayload((prevData) => ({ ...prevData, ["amount"]: amount }))
	// }, [currentIndex, activeTabIndex]);


	useEffect(() => {
		updateUnitSuffix()
	}, [currentIndex, currentStep, activeTabIndex]);

	useGSAP(() => {
		if (isMobile) {
			const el = paymentFormRef.current;
			ScrollTrigger.create({
				trigger: mobileProjectSelectorWrapperRef.current,
				// markers: true,
				start: 'top top',
				endTrigger: paymentFormRef.current,
				pin: true,
				pinSpacing: false,
				end: 'bottom top+=96',
				invalidateOnRefresh: true,
			})
		}
	},{dependencies: [currentStep, currentIndex, showMoreInputsStep2, isMobile], revertOnUpdate: true});

	useGSAP(() => {
		if(isDesktop || isTablet) {
			const el = paymentFormRef.current;
			const offset = el?.getBoundingClientRect()?.height || 0;
			ScrollTrigger.create({
				trigger: paymentFormRef.current,
				// markers: true,
				start: isTablet ? 'top top+=100px' : 'top top',
				// start: 'top top',
				endTrigger: imagesContainerRef.current,
				// end: `bottom top+=${offset}`,
				// end: `bottom top+=${offset}`,
				end: isTablet ? `bottom top+=${offset+100}` : `bottom top+=${offset}`,
				pin: true,
				invalidateOnRefresh: true,
			})
			const payments = gsap.utils.toArray('.single-payment-image');
			payments.forEach((item, index) => {
				ScrollTrigger.create({
					trigger: item,
					start: 'top center',
					invalidateOnRefresh: true,
					onEnter: () => {
						// handleCurrentProjectChange(index)
						handleChangeProject(index)
						// handleChangeCurrentPaymentProject(paymentsData[index].id)
						// createNewSessionStorageItem(paymentsData[index].id)
					},
					onLeaveBack: () => {
						if (index === 0) {
							// handleCurrentProjectChange(0)
							handleChangeProject(0)
						} else {
							// handleCurrentProjectChange(index - 1)
							handleChangeProject(index - 1)
						}
					}
				})
			})
		}
	}, {  dependencies: [viewportWidth, viewportHeight, isDesktop, isTablet, imagesContainerRef], revertOnUpdate: true })

	const options = finalPaymentData.map((item, i) => {
		return {
			// id: getIdWithoutSpecialSymbols(item?.id || ''),
			index: i,
			value: item?.inflectedWord || ''}
	})

	// useEffect(() => {
	// 	if (!router.isReady || !isMobile) return;
	// 	const option = options.find(option => router.asPath.includes(option.id))
	// 	console.log('option',option)
	// 	if (!option) return
	// 	console.log('option2',option)
	// 	handleProjectChange(option)
	// }, [router.isReady, finalPaymentData, isMobile]);
	const mobilePaddingsClass = isMobile ? paddings : '';
	return (
		<>
			{isPaymentProviderError && (
				<TextModal
					isOpen={isPaymentProviderError}
					handleClose={handleClosePaymentProviderErrorModal}
					textContent={paymentProviderErrorModalText}
				/>
			)}
			<StyledPaymentContainer id='payment-container' ref={wrapperRef}
				className={!isPaymentPage ? 'not-payment-page' : ''}
			>
				{/*{!isDesktop && !isTablet && globalPckPayment.length !== 0 && (*/}
				<SinglePaymentImageContainer
					id={globalPckPaymentProject.id}
					// className={isTablet ? '' : 'single-payment-image indent-tablet-2 indent-desktop-8'}
					className={(!isDesktop && !isTablet && globalPckPayment.length !== 0) ? 'single-payment-image indent-desktop-8' : (isTablet && globalPckPayment.length !== 0) ? '' : 'hidden'}
				>
					<FirstBlankModuleContent className={isTablet ? 'col-mobile-8 col-tablet-8 col-desktop-8' :'col-mobile-8 col-tablet-6 col-desktop-8'}>
						<RightSide data={globalPaymentRightBlocks}/>
					</FirstBlankModuleContent>
				</SinglePaymentImageContainer>
				<PaymentsFormContainer ref={paymentFormRef}>
					<PaymentWrapper className={` ${isMobile && showMoreInputsStep2 ? 'mobile-scrollable col-mobile-8 col-tablet-6 col-desktop-8':'col-mobile-8 col-tablet-6 col-desktop-8'} ${!isPaymentPage ? 'not-payment-page' : ''}`}>
						<PaymentsTitleWrapper ref={mobileProjectSelectorWrapperRef} className={isPaymentPage ? 'payment-page' : ''}>
							<p className={`${isPaymentPage ? 'typo-strawford typo-strawford-43' : 'typo-borna typo-borna-57'}`}>{titleIPayFor}&nbsp;</p>
							<PaymentPurpose className={`typo-borna ${isPaymentPage ? 'typo-borna-58' : 'typo-borna-57 not-payment-page'}`}>{currentPaymentData.inflectedWord}</PaymentPurpose>
							<MobileProjectSelectorWrapper>
								{(!isTablet && !isDesktop) && <CustomProjectsSelector
									options={options}
									value={currentIndex}
									onChange={handleProjectChange}
									language={locale}
									placeholder={step2CountryPlaceholder}
								/>}
							</MobileProjectSelectorWrapper>
						</PaymentsTitleWrapper>
						<MobileImagesContainer>
							<SingleMobileImageWrapper>
								<ImageWrapper className='mobile'>
									<Image
										// src={paymentsData?.[currentIndex]?.image?.url || ''}
										src={finalPaymentData?.[currentIndex]?.image?.url || ''}
										alt={'image'}
										fit="cover"
									/>
								</ImageWrapper>
							</SingleMobileImageWrapper>
						</MobileImagesContainer>
						<PaymentStepsContainer>
							<PaymentStepsWrapper className={isMobile ? `mobile-step-${currentStep}` : showMoreInputsStep2 && currentStep === 2 ? 'scrollable' : ''}>
								<TabsWithContentWrapper className={currentStep === 2 ? 'full-height' : ''}>
									{currentStep === 1 && <TabsWrapper>
										<SingleTabWrapper
											onClick={() => handleTabClick(0)}
											className={activeTabIndex === 0 ? 'active' : ''}
										>
											<p className='typo-strawford typo-strawford-59'>{isDesktop ? tabOneTimePayment: tabOneTimePaymentMobile}</p>
											{activeTabIndex === 0 && (
												<AnimatedBackground layoutId='active-tab-item' />
											)}
										</SingleTabWrapper>
										{currentPaymentData.showMonthlyPaymentTab &&<SingleTabWrapper
											onClick={() => handleTabClick(1)}
											className={activeTabIndex === 1 ? 'active' : ''}
										>
											<p className='typo-strawford typo-strawford-59'>{isDesktop ? tabRecurringPayment : tabRecurringPaymentMobile}</p>
											{activeTabIndex === 1 && (
												<AnimatedBackground layoutId='active-tab-item' />
											)}
										</SingleTabWrapper>}
									</TabsWrapper>}
									<TabsContent
										className={currentStep === 1 ? 'has-border' : currentStep === 3 ? 'small-gap' : ''}>
										{/*{currentPaymentData.showMonthlyInfoModal && activeTabIndex === 1 &&*/}
										{/*	<ShowInfoModalText className='typo-strawford'*/}
										{/*		onClick={() => setIsMontlyModalVisible(true)}><span>{paymentMonthlyShowModalInfoText}</span></ShowInfoModalText>}*/}
										{isMonthlyModalVisible && (
											<TextModal
												isOpen={isMonthlyModalVisible}
												handleClose={() => setIsMontlyModalVisible(false)}
												textContent={paymentMonthlyModalInfo}
											/>
										)}
										{currentStep === 1 && <>
											<AmountButtonsWrapper>
												{Array.isArray(currentPaymentData.amountTabs) && currentPaymentData.amountTabs?.map((item, key) => {
													const amountWithoutUnit = item?.amountWithoutUnit || '';
													const description = item?.description || '';
													const pictogramUrl = item?.pictogram?.url || '';
													const pictogramAlt = item?.pictogram?.alt || '';
													return (
														<React.Fragment key={pictogramUrl + key}>
															{(key === currentPaymentData.amountTabs.length - 1) ? (
																<SingleAmountButton
																	className={`${key === currentAmountIndex ? "active" : ""} custom`}
																	$numberOfItems={currentPaymentData.amountTabs.length}
																	onClick={() => handleCustomAmountFocus(key)}>
																	<AmountInputWrapper
																		className={key === currentAmountIndex ? "active" : ""}>
																		<AmountInput
																			id="amount-input"
																			type="number"
																			autoComplete="off"
																			onChange={handleCustomAmount}
																			value={customAmount !== 0 ? customAmount : ''}
																			focus={customAmountFocus.toString()}
																			onFocus={() => setCustomAmountFocus(true)}
																			onBlur={() => setCustomAmountFocus(false)}
																			placeholder={amountWithoutUnit}
																			className={
																				classNames({
																					'dark-blue': !customAmountFocus && key !== currentAmountIndex,
																					'white': customAmountFocus || key === currentAmountIndex || customAmount !== 0,
																					'focus': customAmountFocus,
																					'currency-translate': customAmountFocus || customAmount !== 0,
																					// 'active': key === currentAmountIndex,
																					'has-value': customAmount !== 0,
																					'typo-borna typo-borna-20': true,
																				})
																			}
																		/>
																		<InvisibleDivForUnit
																			id="invisible-div"
																			className={
																				(customAmount !== 0 && customAmount !== '') || customAmountFocus ? '' : 'hidden'
																			}
																		>
																			<span
																				className={customAmountFocus ? 'focus typo-borna typo-borna-20' : "typo-borna typo-borna-20"}>{CURRENCY}</span>
																		</InvisibleDivForUnit>
																	</AmountInputWrapper>
																	{isAmountValidationInfoShown && <AmountValidationErrorTextWrapper className='validation-amount typo-borna'>{paymentAmountValidationText}</AmountValidationErrorTextWrapper>}
																</SingleAmountButton>
															) :
																<SingleAmountButton
																	key={amountWithoutUnit}
																	$numberOfItems={currentPaymentData.amountTabs.length}
																	onClick={() => handleAmountClick(key)}
																	className={key === currentAmountIndex ? "active typo-borna typo-borna-20" : "typo-borna typo-borna-20"}
																>{amountWithoutUnit} {CURRENCY}</SingleAmountButton>
															}
														</React.Fragment>
													)
												})}
											</AmountButtonsWrapper>
											<AmountDescriptionAndPictogramWrapper>
												<AmountDescription className='typo-strawford typo-strawford-61'
													dangerouslySetInnerHTML={getHtmlFromRedactorField(currentPaymentData?.amountTabs?.[currentAmountIndex]?.description || '')}/>
												{(currentPaymentData?.amountTabs?.[currentAmountIndex]?.pictogram?.url || '') &&
													<AmountPictogramWrapper>
														<img
															alt='picto'
															// src={currentPaymentData?.amountTabs?.[currentAmountIndex]?.pictogram?.url || ''}
															src={currentPaymentData?.amountTabs?.[currentAmountIndex]?.pictogram?.url || ''}
														/>
													</AmountPictogramWrapper>}
											</AmountDescriptionAndPictogramWrapper>
										</>}
										{currentStep === 2 && <>
											<StyledDescriptionText className='typo-strawford typo-strawford-62 top-info'
												dangerouslySetInnerHTML={getHtmlFromRedactorField(weNeedYourDataText)}/>
											<form id='payment-form' onSubmit={handleSubmitFormData}>
												<StyledInputsWrapper className={showMoreInputsStep2 ? 'scrollable' : ''}>
													<CustomInput
														name="firstName"
														placeholder={`${step2NamePlaceholder}*`}
														type="text"
														value={paymentPayload.firstName}
														onChange={handleInputChange}
														validate={(value) => {
															return validateInput(value)
														}}
														errorMessage={
															paymentPayload.firstName && containsProfanity(paymentPayload.firstName)
																? validationErrors[locale].profanity
																: `${validationErrors[locale].required} (${validationErrors[locale].minLength})`
														}
														maxlength={50}
														icon={ICONS.NAME}
														required
													/>
													<CustomInput
														name="lastName"
														placeholder={`${step2SurnamePlaceholder}*`}
														type="text"
														maxlength={50}
														value={paymentPayload.lastName}
														onChange={handleInputChange}
														validate={(value) => {
															return validateInput(value)
														}}
														errorMessage={
															paymentPayload.lastName && containsProfanity(paymentPayload.lastName)
																? validationErrors[locale].profanity
																: `${validationErrors[locale].required} (${validationErrors[locale].minLength})`
														}
														icon={ICONS.SURNAME}
														required
													/>
													<CustomInput
														name="email"
														placeholder={`${step2EmailPlaceholder}*`}
														type="email"
														maxlength={75}
														value={paymentPayload.email}
														onChange={handleInputChange}
														validate={(value) => {
															return validateEmailInput(value)
														}}
														errorMessage={
															paymentPayload.email && containsProfanity(paymentPayload.email)
																? validationErrors[locale].profanity
																: validationErrors[locale].invalid
														}
														icon={ICONS.CONTACT}
														required
													/>
													{showMoreInputsStep2 && (
														<>
															<CountrySelector
																value={paymentPayload.country}
																onChange={handleCountryChange}
																language={locale}
																placeholder={step2CountryPlaceholder}
															/>
															<StyledTwoInputsInRowWrapper>
																<PhonePrefixSelector
																	value={paymentPayload.phoneNumberPrefix}
																	onChange={handlePhonePrefixChange}
																	countryCode={currentPrefixCountryCode}
																	language={locale}
																	placeholder={'Prefix'}
																/>
																<CustomInput
																	name="phoneNumber"
																	placeholder={step2PhonePlaceholder}
																	type="tel"
																	value={paymentPayload.phoneNumber}
																	// onChange={handleInputChange}
																	onChange={handlePhoneNumberInputChange}
																	validate={validatePhoneNumber}
																	// pattern="[0-9]*"
																	errorMessage="Nieprawidłowy numer telefonu"
																	onceSubmitted={isOnceSubmitted}
																	maxlength={15}
																	icon={ICONS.PHONE}
																	required
																/>
															</StyledTwoInputsInRowWrapper>
															<CustomInput
																name="street"
																placeholder={step2StreetPlaceholder}
																type="text"
																value={paymentPayload.street}
																onChange={handleInputChange}
																validate={(value) => value.trim() !== ''}
																errorMessage="Wypełnij pole"
																icon={ICONS.STREET}
															/>
															<StyledTwoInputsInRowWrapper>
																<CustomInput
																	name="city"
																	placeholder={step2CityPlaceholder}
																	type="text"
																	value={paymentPayload.city}
																	onChange={handleInputChange}
																	validate={(value) => value.trim() !== ''}
																	errorMessage="Wypełnij pole"
																	icon={ICONS.CITY}
																/>
																<CustomInput
																	name="zipCode"
																	placeholder={step2ZipCodePlaceholder}
																	type="text"
																	value={paymentPayload.zipCode}
																	onChange={handleInputChange}
																	validate={validateZipCode}
																	// validate={(value) => value.trim() !== ''}
																	required
																	onceSubmitted={isOnceSubmitted}
																	errorMessage="Wpisz poprawny kod pocztowy"
																	icon={ICONS.ZIP_CODE}
																/>
															</StyledTwoInputsInRowWrapper>
														</>
													)}
												</StyledInputsWrapper>
												{/*{!showMoreInputsStep2 && <StyledDescriptionText className='more-data typo-strawford typo-strawford-15'>Chcę podać więcej <span onClick={showMoreInputs} className='highlight'>danych kontaktowych</span></StyledDescriptionText>}*/}
												{!showMoreInputsStep2 && <StyledDescriptionText onClick={showMoreInputs}
													className='more-data typo-strawford typo-strawford-62'
													dangerouslySetInnerHTML={getHtmlFromRedactorField(iWantMoreData)}/>}
												<CustomCheckboxContainer>
													<CustomCheckbox name='terms' agreement={agreement} checked={isChecked}
														onChange={handleCheckboxToggle} required={true}/>
												</CustomCheckboxContainer>
												<BottomNavigatingContainer
													className={isMobile ? `mobile-step-${currentStep}` : ''}>
													<BackButton onClick={handleBackButtonClick}>
														<ArrowWrapper>
															<SimpleIconButton color={colors.chilliRed} />
														</ArrowWrapper>
														<p>{backButtonText}</p>
													</BackButton>
													<Button variant={BUTTON_VARIANTS.SEPTENARY} type="submit">
														{buttonTextIPay}
														<ButtonIconWrapper>
															<Icon name={ICONS.CHEVRON}/>
														</ButtonIconWrapper>
													</Button>
													<CounterContainer>
														<StyledStepCounter>
															<p className='typo-strawford typo-strawford-08'><span
																className='current'>{currentStep}</span>/3</p>
														</StyledStepCounter>
													</CounterContainer>
												</BottomNavigatingContainer>
											</form>
										</>}
										{currentStep === 3 && <>
											<Summary>
												<SingleSummaryRow>
													<div
														className="typo-strawford typo-strawford-63 label">{summaryAmount}:
													</div>
													<div
														className="typo-strawford typo-strawford-63 value">{paymentPayload.amount}{CURRENCY}
													</div>
												</SingleSummaryRow>
												<SingleSummaryRow>
													<div
														className="typo-strawford typo-strawford-63 label">{summaryPaymentType}:
													</div>
													<div
														className="typo-strawford typo-strawford-63 value">{paymentPayload.paymentType === 'SUBSCRIPTION' ? 'miesięczna' : 'jednorazowa'}</div>
												</SingleSummaryRow>
											</Summary>
										</>}
										{currentStep === 3 && (
											<>
												<div
													className="typo-strawford typo-strawford-63 label label-choose">{summaryPaymentProvider}:
												</div>
												<PaymentProvidersWrapper>
													<SinglePaymentProvider
														onClick={() => handleSetProvider('PAYU')}
														className={paymentPayload.provider === 'PAYU' ? 'active' : ''}>
														<ProviderIcon>
															<Image src={payuLogoUrl} fit="contain" alt="PayU" />
														</ProviderIcon>
													</SinglePaymentProvider>
													<SinglePaymentProvider
														onClick={() => handleSetProvider('PAYPAL')}
														className={paymentPayload.provider === 'PAYPAL' ? 'active' : ''}
													>
														<ProviderIcon>
															<Image src={paypalLogoUrl} fit="contain" alt="PayPal"   />
														</ProviderIcon>
													</SinglePaymentProvider>
													<SinglePaymentProvider
														onClick={() => handleSetProvider('STRIPE')}
														className={paymentPayload.provider === 'STRIPE' ? 'active' : ''}
													>
														<ProviderIcon>
															<Image src={stripeLogoUrl} fit="contain" alt="Stripe"  />
														</ProviderIcon>
													</SinglePaymentProvider>
												</PaymentProvidersWrapper>
											</>
										)}
										{currentStep === 3 && activeTabIndex === 1 && paymentPayload.provider === 'PAYU' && <div
											className="typo-strawford typo-strawford-63 label add-payment-card">Dodaj kartę do płatności cyklicznej:
										</div>}
										 <SecureFormWrapper
											className={currentStep === 3 && activeTabIndex === 1 && paymentPayload.provider === 'PAYU' ? 'visible' : ''}>
											<PayUSecureForm
												locale={locale}
												showForm={currentStep === 3}
												tokenize={tokenize}
												posId={posIdPayU}
												// handleToken={(token) => setPaymentPayload((prevData) => ({
												// 	...prevData,
												// 	["card"]: token
												// }))}
											/>
										</SecureFormWrapper>
									</TabsContent>
								</TabsWithContentWrapper>
								{currentStep !== 2 && <BottomNavigatingContainer className={isMobile ? `mobile-step-${currentStep}` : ''}>
									{(currentStep === 3 || currentStep === 1) &&
										<BackButton className={`step-${currentStep}`} onClick={handleBackButtonClick}>
											<ArrowWrapper>
												<SimpleIconButton color={colors.chilliRed} />
											</ArrowWrapper>
											<p>{backButtonText}</p>
										</BackButton>}
									<Button variant={BUTTON_VARIANTS.SEPTENARY} onClick={currentStep === 3 ? handleSendPaymentRequest : paymentPayload.amount >= 2 ? handleButtonClick : validateCustomAmount}>
										{buttonTextIPay}
										<ButtonIconWrapper>
											<Icon name={ICONS.CHEVRON}/>
										</ButtonIconWrapper>
									</Button>
									<CounterContainer className={`step-${currentStep}`}>
										<StyledStepCounter>
											<p className='typo-strawford typo-strawford-08'>
												<span className='current'>{currentStep}</span>/3</p>
										</StyledStepCounter>
									</CounterContainer>
								</BottomNavigatingContainer>}
							</PaymentStepsWrapper>
						</PaymentStepsContainer>
					</PaymentWrapper>
				</PaymentsFormContainer>
				{(isDesktop || isTablet) && (
					<ImagesContainer ref={imagesContainerRef}>
						{globalPckPayment.length !== 0 && (
							<SinglePaymentImageContainer
								id={globalPckPaymentProject.id}
								// onClick={() => scrollToPayment(globalPckPaymentProject.id)}
								className={`single-payment-image indent-tablet-2 indent-desktop-8 ${!isPaymentPage ? 'not-payment-page' : ''}`}
							>
								{!isTablet && (
									<FirstBlankModuleContent className='col-tablet-8 col-desktop-8'>
										<RightSide data={globalPaymentRightBlocks}/>
									</FirstBlankModuleContent>
								)}
								{isTablet && (
									<ImageWrapper className='col-tablet-6 col-desktop-8' >
										<Image
											src={finalPaymentData[0]?.image?.url}
											alt={'alt'}
											fit="cover"
										/>
									</ImageWrapper>
								)}
							</SinglePaymentImageContainer>
						)}
						{paymentsData.map((item) => {
							const id = getIdWithoutSpecialSymbols(item?.id || '')
							return (
								<SinglePaymentImageContainer id={id} key={getMapKey(item)} className={`single-payment-image indent-tablet-2 indent-desktop-8 ${!isPaymentPage ? 'not-payment-page' : ''}`}>
									<PaymentImage data={item} className='col-tablet-6 col-desktop-8' />
								</SinglePaymentImageContainer>
							)
						})}
					</ImagesContainer>
				)}
				{!isAction && <FixedPayloadLiveSummary>
					<p style={{marginBottom: 10, color: "indianred"}} className="typo-strawford typo-strawford-12">Dane do API:</p>
					<Summary className='fixed'>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Projekt:</div>
							<div className="typo-strawford typo-strawford-12 value">{currentPaymentData.inflectedWord}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Card Token:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.card}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Kwota:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.amount}{CURRENCY}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Imie:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.firstName}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Nazwisko:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.lastName}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">ProjectId:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.projectId}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Email:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.email}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Prefix:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.phoneNumberPrefix}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Telefon:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.phoneNumber}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Miasto:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.city}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Ulica:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.street}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Kod pocztowy:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.zipCode}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Kraj:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.country}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Oddział:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.branch}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Provider:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.provider}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Origin:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.origin}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">deviceType:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.deviceType}</div>
						</SingleSummaryRow>
						<SingleSummaryRow>
							<div className="typo-strawford typo-strawford-12 label">Płatność:</div>
							<div className="typo-strawford typo-strawford-12 value">{paymentPayload.paymentType === 'SUBSCRIPTION' ? 'miesięczna' : 'jednorazowa'}</div>
						</SingleSummaryRow>
					</Summary>
				</FixedPayloadLiveSummary>}
			</StyledPaymentContainer>
		</>
	);
};

export default Payment;
